export default class Constants {
  static squareLimits = {
    ['min_zoom']: 18,
    ['max_zoom']: 18
  };
}
